import { CampoDeEtiquetaDisponivel, EntradaDeImpressaoDeModeloDeEtiqueta,
	EntradaDeResolucaoDeValoresDeEtiqueta, ModeloDeEtiqueta, ValoresDeCamposDeEtiqueta } from '@/models/ModeloDeEtiqueta'
import { FatiaDeImpressaoDeEtiquetas, JobDeImpressaoNoHistorico, ResultadoDeEnvioParaImpressao } from "@/models/EstacaoDeImpressao"
import { Page } from '@/models/Page'
import { AxiosRequestConfig } from 'axios'
import { Inject } from 'inversify-props'
import type { ModeloDeEtiquetaServiceAdapter } from '@/usecases'

export class ModeloDeEtiquetaUseCase {
	@Inject('ModeloDeEtiquetaServiceAdapter')
	private modeloDeEtiquetaService!: ModeloDeEtiquetaServiceAdapter

	createModeloDeEtiqueta = async (modelo: ModeloDeEtiqueta): Promise<ModeloDeEtiqueta> =>
		await this.modeloDeEtiquetaService.createModeloDeEtiqueta(modelo)

	updateModeloDeEtiqueta = async (modeloEtiquetaId: string, modelo: ModeloDeEtiqueta): Promise<ModeloDeEtiqueta> =>
		await this.modeloDeEtiquetaService.updateModeloDeEtiqueta(modeloEtiquetaId, modelo)

	findModeloDeEtiqueta = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ModeloDeEtiqueta>> =>
		await this.modeloDeEtiquetaService.findModeloDeEtiqueta(params, config)

	findModeloEtiquetaById = async (modeloEtiquetaId: string, config?: AxiosRequestConfig): Promise<ModeloDeEtiqueta> =>
		await this.modeloDeEtiquetaService.findModeloEtiquetaById(modeloEtiquetaId, config)

	deleteModeloDeEtiqueta = async (modeloEtiquetaId: string, config?: AxiosRequestConfig): Promise<void> =>
		await this.modeloDeEtiquetaService.deleteModeloDeEtiqueta(modeloEtiquetaId, config)

	listarCamposDisponiveis = async (config?: AxiosRequestConfig): Promise<CampoDeEtiquetaDisponivel[]> =>
		await this.modeloDeEtiquetaService.listarCamposDisponiveis(config)

	resolverValoresDeCamposDeEtiqueta = async (entrada: EntradaDeResolucaoDeValoresDeEtiqueta, config?: AxiosRequestConfig): Promise<ValoresDeCamposDeEtiqueta[]> =>
		await this.modeloDeEtiquetaService.resolverValoresDeCamposDeEtiqueta(entrada, config)

	gerarImpressaoParaEstacao = async (estacaoId: string, entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<FatiaDeImpressaoDeEtiquetas[]> =>
		await this.modeloDeEtiquetaService.gerarImpressaoParaEstacao(estacaoId, entrada, config)

	imprimirNaEstacao = async (estacaoId: string, entrada: EntradaDeImpressaoDeModeloDeEtiqueta, config?: AxiosRequestConfig): Promise<ResultadoDeEnvioParaImpressao> =>
		await this.modeloDeEtiquetaService.imprimirNaEstacao(estacaoId, entrada, config)

	buscarHistoricoDeImpressao = async (lojaId: string, limite?: number, config?: AxiosRequestConfig): Promise<JobDeImpressaoNoHistorico[]> =>
		await this.modeloDeEtiquetaService.buscarHistoricoDeImpressao(lojaId, limite, config)

	reimprimirJob = async (jobId: string, estacaoId?: string, config?: AxiosRequestConfig): Promise<ResultadoDeEnvioParaImpressao> =>
		await this.modeloDeEtiquetaService.reimprimirJob(jobId, estacaoId, config)
}
